import React, { useEffect } from "react";
import AOS from "aos";
import styles from "../styles/ServiceHighlightHome.module.css";

const serviceData = [
  {
    id: "01",
    title: "Stronger Brand Identity",
    description:
      "Our crafted strategies and visual systems build lasting brand recognition and credibility, helping you earn trust and stand apart.",
    image: "/highlights/graphics-1.jpg",
  },
  {
    id: "02",
    title: "Higher Engagement & Conversions",
    description:
      "From UI to content flow, every touchpoint is optimised to increase interaction, retention and conversion naturally.",
    image: "/highlights/asset-man-1.jpg",
  },
  {
    id: "03",
    title: "Enhanced Storytelling",
    description:
      "We turn complexity into clarity by blending data, motion and design, so your message connects and sticks.",
    image: "/highlights/graphics-3.jpg",
  },
  {
    id: "04",
    title: "Competitive Differentiation",
    description:
      "Through insight-led design and positioning, we help you rise above the noise and lead with confidence in your category.",
    image: "/highlights/graphics-4.jpg",
  },
];

const ServiceHighlightHome = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section className={styles["shh-highlight-section"]}>
      <div className="container">
        {/* Desktop / Tablet */}
        <div className="d-none d-md-block">
          <div className={`row ${styles["shh-grid-row"]}`}>
            {serviceData.slice(0, 2).map((item) => (
              <React.Fragment key={item.id}>
                <div
                  className={`col-md-6 col-lg-3 p-0 ${styles["shh-imgCol"]}`}
                  data-aos="fade-up"
                >
                  <img src={item.image} alt={item.title} className={styles["shh-img"]} />
                </div>

                <div
                  className="col-md-6 col-lg-3 p-0 d-flex align-items-center"
                  data-aos="fade-up"
                >
                  <div className={styles["shh-text-block"]}>
                    <span className={styles["shh-number"]}>{item.id}</span>
                    <h5 className="box-title">{item.title}</h5>
                    <h6 className="box-description">{item.description}</h6>
                  </div>
                </div>
              </React.Fragment>
            ))}
          </div>

          <div className={`row ${styles["shh-grid-row"]}`}>
            {serviceData.slice(2, 4).map((item) => (
              <React.Fragment key={item.id}>
                <div
                  className="col-md-6 col-lg-3 p-0 d-flex align-items-center"
                  data-aos="fade-up"
                >
                  <div className={styles["shh-text-block"]}>
                    <span className={styles["shh-number"]}>{item.id}</span>
                    <h5 className="box-title">{item.title}</h5>
                    <h6 className="box-description">{item.description}</h6>
                  </div>
                </div>

                <div
                  className={`col-md-6 col-lg-3 p-0 ${styles["shh-imgCol"]}`}
                  data-aos="fade-up"
                >
                  <img src={item.image} alt={item.title} className={styles["shh-img"]} />
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>

        {/* Mobile Layout */}
        <div className="d-block d-md-none">
          {serviceData.map((item) => (
            <div key={item.id} className={styles["shh-card"]} data-aos="fade-up">
              <img src={item.image} alt={item.title} className={styles["shh-img"]} />
              <div className={styles["shh-text-block"]}>
                <span className={styles["shh-number"]}>{item.id}</span>
                <h5 className="box-title">{item.title}</h5>
                <p className="box-description">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceHighlightHome;
